import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { TestPageWeb } from "@lt-web-platform/test-page-web";
import useRbacPermissions from "../../../hooks/useRbacPermissions";


const TestPageWrapper = ({ pageType }) => {
  // Replace mapStateToProps with useSelector
  const featureFlags = useSelector(state => state.userInfo.featureFlags.data);
  const userInfo = useSelector(state => state.userInfo.userInfo);
  const orgPreferences = useSelector(state => state.orgPreferencesReducer?.orgPreferences);
  const { test } = useRbacPermissions();
  // useMemo so the prop reference is stable across renders when the cached
  // matrix decision hasn't changed -- otherwise every parent re-render forces
  // every memoised TestPageWeb descendant to re-render too.
  const rbac = useMemo(
    () => ({
      canRead:    test.canRead,
      canCreate:  test.canCreate,
      canUpdate:  test.canUpdate,
      canDelete:  test.canDelete,
      canExecute: test.canExecute
    }),
    [test.canRead, test.canCreate, test.canUpdate, test.canDelete, test.canExecute]
  );

  // Webpack 5: Use __REACT_APP_ENV__ which is a real iterable object
  // (injected by DefinePlugin - see config/env.js)
  // eslint-disable-next-line no-undef
  const envs = typeof __REACT_APP_ENV__ !== "undefined" ? __REACT_APP_ENV__ : (window?._env_ || {});

  return (
    <TestPageWeb
      featureFlags={featureFlags}
      userInfo={userInfo}
      env={envs}
      pageType={pageType}
      orgPreferences={orgPreferences}
      rbac={rbac}
    />
  );
};

export default TestPageWrapper;
